'use client';

import { useEffect } from 'react';
import { clarityEvent } from '@/lib/clarity';

export function ClarityProductViewTracker() {
  useEffect(() => {
    clarityEvent('ProductView');
  }, []);

  return null;
}
